module.exports = __webpack_public_path__ + "member-birthday-white.svg?c8f28daa4e2ec0eecd3c092c28b458d3";